// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"LtiLoadingSpinner_loading_container__3Tw54","loadingContainer":"LtiLoadingSpinner_loading_container__3Tw54"};